export const facebookPost = {
  pageId: '',
  accessToken: '',
  type: 'text',
  message: 'Sample text...',
  mediaAttachments: [],
  link: '',
  linkMetadata: {}
}
